"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var TreeSelect = /** @class */function (_super) {
  __extends(TreeSelect, _super);
  function TreeSelect(props) {
    var _this = _super.call(this, props) || this;
    _this.state = JSON.parse(JSON.stringify(init(_this.props.data)));
    return _this;
  }
  TreeSelect.prototype.toggleCollapse = function (id) {
    var _a;
    this.setState((_a = {}, _a[id] = __assign(__assign({}, this.state[id]), {
      expanded: !this.state[id].expanded
    }), _a));
  };
  TreeSelect.prototype.handleChange = function (id, type, event) {
    var _this = this;
    if (type === 'radio') {
      this.setState(function (prevState) {
        var mutatedState = prevState;
        // eslint-disable-next-line no-restricted-syntax
        for (var idParams in mutatedState) {
          if (mutatedState[idParams].type === 'radio') {
            mutatedState[idParams].checked = false;
          }
        }
        mutatedState[id].checked = !mutatedState[id].checked;
        return mutatedState;
      }, function () {
        var _a, _b;
        (_b = (_a = _this.props) === null || _a === void 0 ? void 0 : _a.onSelect) === null || _b === void 0 ? void 0 : _b.call(_a, _this.state[id], event);
        // console.table(this.state)
      });
    } else if (type === 'checkbox') {
      this.setState(function (prevState) {
        var _a;
        return _a = {}, _a[id] = __assign(__assign({}, prevState[id]), {
          checked: !prevState[id].checked
        }), _a;
      }, function () {
        var _a, _b;
        return (_b = (_a = _this.props) === null || _a === void 0 ? void 0 : _a.onSelect) === null || _b === void 0 ? void 0 : _b.call(_a, _this.state[id], event);
      });
    }
  };
  TreeSelect.prototype.componentDidUpdate = function () {
    var _a, _b;
    (_b = (_a = this.props) === null || _a === void 0 ? void 0 : _a.onChange) === null || _b === void 0 ? void 0 : _b.call(_a, this.state);
  };
  TreeSelect.prototype.render = function () {
    var _this = this;
    var _a;
    var renderNode = (_a = this.props.render) !== null && _a !== void 0 ? _a : function (node) {
      var _a;
      return (_a = node.name) !== null && _a !== void 0 ? _a : node.value;
    };
    if (this.props.mobile) {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      var _Node_ = function Node_1(_a) {
        var node = _a.node;
        var name = node.name,
          value = node.value,
          id = node.id,
          _b = node.type,
          type = _b === void 0 ? 'radio' : _b,
          children = node.children;
        if (!name && !value) return null;
        if (!renderNode(node)) {
          return null;
        }
        if (!children) {
          // item
          return /*#__PURE__*/_react["default"].createElement("li", {
            className: "node leaf",
            key: id + "-leaf"
          }, /*#__PURE__*/_react["default"].createElement("label", {
            className: (0, _classnames["default"])('radio-btn-wrapper', {
              checked: _this.state[id].checked
            }),
            onClick: function onClick(event) {
              _this.handleChange(id, type, event);
            }
          }, /*#__PURE__*/_react["default"].createElement("input", {
            type: type,
            id: id,
            name: "radio-group",
            title: name !== null && name !== void 0 ? name : value,
            value: value
          }), /*#__PURE__*/_react["default"].createElement("div", {
            className: "radio-text"
          }, renderNode(node))));
        }
        // group
        var expanded = _this.state[id].expanded;
        return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("li", {
          className: "node root",
          key: id + "-root"
        }, /*#__PURE__*/_react["default"].createElement("label", {
          className: "collapse-toggle-label"
        }, /*#__PURE__*/_react["default"].createElement("button", {
          className: "collapse-toggle-btn " + (expanded ? 'expanded' : 'collapsed'),
          onClick: function onClick() {
            return _this.toggleCollapse(id);
          },
          title: "toggle collapse"
        }, /*#__PURE__*/_react["default"].createElement("img", {
          src: "https://main.qcloudimg.com/qcintl-cms/154/1622119439624/829d95b02396a7983828136eb1979220.svg"
        })), renderNode(node))), /*#__PURE__*/_react["default"].createElement("li", {
          className: "node children " + (expanded ? 'expanded' : 'collapsed'),
          key: (value !== null && value !== void 0 ? value : name) + "-children"
        }, /*#__PURE__*/_react["default"].createElement("ul", {
          className: "node root"
        }, children === null || children === void 0 ? void 0 : children.map(function (child) {
          return /*#__PURE__*/_react["default"].createElement(_Node_, {
            node: child,
            key: "root-node-" + child.id
          });
        }))));
      };
      return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("ul", {
        className: (0, _classnames["default"])('tree-select-mobile', this.props.className)
      }, this.props.data.map(function (child) {
        return /*#__PURE__*/_react["default"].createElement(_Node_, {
          node: child,
          checked: _this.state[child.id].checked,
          key: "tree-root-node-" + child.id
        });
      })));
    }
    // DEFAULT: Desktop
    // eslint-disable-next-line @typescript-eslint/naming-convention
    var _Node = function Node(_a) {
      var node = _a.node;
      if (!node || !renderNode(node)) return null;
      var name = node.name,
        value = node.value,
        id = node.id,
        _b = node.type,
        type = _b === void 0 ? 'radio' : _b,
        children = node.children;
      if (!children) {
        // item
        return /*#__PURE__*/_react["default"].createElement("li", {
          className: "node leaf",
          key: id + "-leaf"
        }, /*#__PURE__*/_react["default"].createElement("label", {
          className: "radio-btn-wrapper",
          onClick: function onClick(event) {
            _this.handleChange(id, type, event);
          }
        }, /*#__PURE__*/_react["default"].createElement("input", {
          type: type,
          id: id,
          name: "radio-group",
          title: name !== null && name !== void 0 ? name : value,
          value: value
        }), /*#__PURE__*/_react["default"].createElement("button", {
          className: (0, _classnames["default"])({
            'radio-control': type === 'radio',
            'checkbox-control': type === 'checkbox',
            checked: _this.state[id].checked
          }),
          title: "radio-control"
        }, type === 'checkbox' ? (/*#__PURE__*/_react["default"].createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24",
          "aria-hidden": "true",
          focusable: "false"
        }, /*#__PURE__*/_react["default"].createElement("path", {
          fill: "none",
          stroke: "currentColor",
          strokeWidth: "4",
          d: "M1.73 12.91l6.37 6.37L22.79 4.59"
        }))) : null), /*#__PURE__*/_react["default"].createElement("div", {
          className: "radio-text"
        }, renderNode(node))));
      }
      // group
      var expanded = _this.state[id].expanded;
      return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("li", {
        className: "node root",
        key: (id !== null && id !== void 0 ? id : name) + "-root"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "collapse-toggle-label"
      }, /*#__PURE__*/_react["default"].createElement("button", {
        className: "collapse-toggle-btn " + (expanded ? 'expanded' : 'collapsed'),
        onClick: function onClick() {
          return _this.toggleCollapse(id);
        },
        title: "toggle collapse"
      }), renderNode(node))), /*#__PURE__*/_react["default"].createElement("li", {
        className: "node children " + (expanded ? 'expanded' : 'collapsed'),
        key: (value !== null && value !== void 0 ? value : name) + "-children"
      }, /*#__PURE__*/_react["default"].createElement("ul", {
        className: "node root"
      }, children === null || children === void 0 ? void 0 : children.map(function (child) {
        return /*#__PURE__*/_react["default"].createElement(_Node, {
          node: child,
          key: "root-node-" + child.id
        });
      }))));
    };
    return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("ul", {
      className: (0, _classnames["default"])('tree-select', this.props.className)
    }, this.props.data.map(function (child) {
      return /*#__PURE__*/_react["default"].createElement(_Node, {
        node: child,
        checked: _this.state[child.id].checked,
        key: "tree-root-node-" + child.id
      });
    })));
  };
  return TreeSelect;
}(_react["default"].Component);
var _default = exports["default"] = TreeSelect;
var init = function init(roots, defaultType) {
  if (defaultType === void 0) {
    defaultType = 'radio';
  }
  var obj = {};
  var _recur = function recur(node) {
    var _a;
    if (!node) return;
    obj[node.id] = node;
    obj[node.id].checked = (_a = node.checked) !== null && _a !== void 0 ? _a : false;
    // obj[node.value].type = obj[node.value].type || defaultType;
    obj[node.id].type = defaultType;
    if (!node.children) return;
    for (var _i = 0, _b = node.children; _i < _b.length; _i++) {
      var child = _b[_i];
      _recur(child);
    }
  };
  for (var _i = 0, roots_1 = roots; _i < roots_1.length; _i++) {
    var node = roots_1[_i];
    _recur(node);
  }
  return obj;
};